function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */

/* eslint-disable shopify/prefer-early-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getSizedImageUrl } from '@shopify/theme-images';
import CartLineItem from '../components/cartLineItem';
import { useShopifyCart } from '../../common/hooks';
export default function CartListing(_ref) {
  var _currentCart$items2;

  var initialCart = _ref.initialCart,
      headerCountElem = _ref.headerCountElem,
      subtotalElem = _ref.subtotalElem,
      savingsElem = _ref.savingsElem,
      savingsContainerElem = _ref.savingsContainerElem,
      onCartUpdate = _ref.onCartUpdate;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentCart = _useState2[0],
      setCurrentCart = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      altRedirectMap = _useState4[0],
      setAltRedirectMap = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      initialOfferProductIds = _useState6[0],
      setInitialOfferProductIds = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      initialEbookCoachingVariantIds = _useState8[0],
      setInitialEbookCoachingVariantIds = _useState8[1];

  var _useShopifyCart = useShopifyCart(),
      error = _useShopifyCart.error,
      updatedCart = _useShopifyCart.cart,
      updateCartDebounced = _useShopifyCart.updateCartDebounced;

  useEffect(function () {
    setCurrentCart(initialCart); // cache the cart line item key for offer products, since product tag data exists on initial render only

    var productIds = initialCart.items.filter(function (item) {
      return item.product_tags.some(function (tag) {
        return tag === '1_3_6_Offer' || tag === '1_3_6_Flavor_Offer' || tag === '1_3_6_SNS_Offer';
      });
    }).map(function (item) {
      return item.product_id;
    });
    setInitialOfferProductIds(productIds); // save the list of ebook and coaching variant ids in the initial cart
    // this is used to know what to remove when all offer products are removed
    // to prevent the cart from entering an invalid state

    var variantIds = initialCart.items.filter(function (item) {
      return item.product_tags.some(function (tag) {
        return tag === 'ebook' || tag === 'coaching';
      });
    }).map(function (item) {
      return item.variant_id;
    });
    setInitialEbookCoachingVariantIds(variantIds);

    try {
      var _window$bt, _window$bt$productsMe;

      // make a set of handles for alternate products that are in the initial cart
      var altHandleSet = new Set(initialCart.items.filter(function (item) {
        return item.product_tags.includes('alternate_product_pdp');
      }).map(function (item) {
        return item.handle;
      })); // make an object that maps alt handles to original handles for items in the initial cart

      setAltRedirectMap((_window$bt = window.bt) === null || _window$bt === void 0 ? void 0 : (_window$bt$productsMe = _window$bt.productsMeta) === null || _window$bt$productsMe === void 0 ? void 0 : _window$bt$productsMe.reduce(function (prev, curr) {
        if (curr.overrideProductHandle && altHandleSet.has(curr.overrideProductHandle)) {
          prev[curr.overrideProductHandle] = curr.handle;
        }

        return prev;
      }, {}));
    } catch (err) {
      console.error('Error creating alternate redirect map:', err);
    }

    return function () {
      updateCartDebounced.cancel();
    };
  }, []);
  useEffect(function () {
    if (currentCart) {
      var _currentCart$items;

      $(headerCountElem).text("(".concat(currentCart.item_count, ")"));
      $(subtotalElem).text(formatMoney(currentCart.total_price));
      var totalSavings = currentCart === null || currentCart === void 0 ? void 0 : (_currentCart$items = currentCart.items) === null || _currentCart$items === void 0 ? void 0 : _currentCart$items.reduce(function (acc, item) {
        var compareAtPrice = calculateCompareAtPrice(item);
        var originalLinePrice = calculateOriginalLinePrice(item, compareAtPrice);
        return acc + originalLinePrice - item.final_line_price;
      }, 0);
      $(savingsContainerElem).toggle(totalSavings !== 0);
      $(savingsElem).text(formatMoney(totalSavings));
    }
  }, [currentCart]);
  useEffect(function () {
    if (updatedCart) {
      if (updatedCart.items.length === 0) {
        window.location.reload();
      } else {
        // eslint-disable-next-line no-unused-expressions
        onCartUpdate === null || onCartUpdate === void 0 ? void 0 : onCartUpdate(updatedCart);
        setCurrentCart(updatedCart);
      }
    }
  }, [updatedCart]);
  useEffect(function () {
    if (error) {
      window.alert('An error occurred updating the cart.  Please refresh the page and try again.');
      console.error('Error updating cart', error);
    }
  }, [error]);

  function formatMoney(amount) {
    return window.Shopify.formatMoney(amount, window.Shopify.money_format);
  }

  function handleLineItemQtyChange(lineItemKey, newQty) {
    var freeGiftUpdates = {};

    if (newQty === 0) {
      // excluding the line item being removed, check if there are any other offer products remaining in cart to determine if the gifts should be removed
      var remainingOfferProducts = currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.filter(function (item) {
        return (initialOfferProductIds === null || initialOfferProductIds === void 0 ? void 0 : initialOfferProductIds.includes(item.product_id)) && item.key !== lineItemKey;
      });

      if (remainingOfferProducts.length === 0) {
        freeGiftUpdates = currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.reduce(function (updateObj, item) {
          if (initialEbookCoachingVariantIds.includes(item.variant_id)) {
            console.debug('Removing free gift from cart because no offer products exist', item.variant_id, item.key);
            updateObj[item.key] = 0;
          }

          return updateObj;
        }, {});
      }
    }

    updateCartDebounced(_objectSpread(_defineProperty({}, lineItemKey, newQty), freeGiftUpdates));
  }

  function calculateCompareAtPrice(lineItem) {
    var _lineItem$selling_pla;

    var initialLineItem = initialCart.items.find(function (elem) {
      return elem.key === lineItem.key;
    });
    return ((_lineItem$selling_pla = lineItem.selling_plan_allocation) === null || _lineItem$selling_pla === void 0 ? void 0 : _lineItem$selling_pla.compare_at_price) || lineItem.variant_compare_at_price || (initialLineItem === null || initialLineItem === void 0 ? void 0 : initialLineItem.variant_compare_at_price);
  }

  function calculateOriginalLinePrice(lineItem, compareAtPrice) {
    return compareAtPrice * lineItem.quantity || lineItem.original_line_price;
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", {
    className: "cart__row cart__header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    colSpan: "2"
  }, "Product"), /*#__PURE__*/React.createElement("th", {
    className: "text-right"
  }, "Price"), /*#__PURE__*/React.createElement("th", {
    className: "text-right cart__qty-header"
  }, "Quantity"), /*#__PURE__*/React.createElement("th", {
    className: "text-right"
  }, "Total"))), /*#__PURE__*/React.createElement("tbody", null, currentCart === null || currentCart === void 0 ? void 0 : (_currentCart$items2 = currentCart.items) === null || _currentCart$items2 === void 0 ? void 0 : _currentCart$items2.map(function (item, index) {
    var _item$selling_plan_al, _item$selling_plan_al2;

    var compareAtPrice = calculateCompareAtPrice(item);
    var mainHandle = altRedirectMap[item.handle];
    var url = mainHandle ? item.url.replace("/".concat(item.handle), "/".concat(mainHandle)) : item.url;
    return /*#__PURE__*/React.createElement(CartLineItem, {
      key: item.key,
      id: item.key,
      productUrl: url,
      productTitle: item.product_title,
      productImgSrc: getSizedImageUrl(item.image, '95x95') || item.image,
      isFirst: index === 0,
      lineItemTitle: item.title,
      variantOptions: item.options_with_values.filter(function (option) {
        return option.name !== 'Title' && option.name !== 'Choose Flavor';
      }),
      sellingPlanName: (_item$selling_plan_al = item.selling_plan_allocation) === null || _item$selling_plan_al === void 0 ? void 0 : (_item$selling_plan_al2 = _item$selling_plan_al.selling_plan) === null || _item$selling_plan_al2 === void 0 ? void 0 : _item$selling_plan_al2.name,
      originalPrice: compareAtPrice || item.original_price,
      finalPrice: item.final_price,
      originalLinePrice: compareAtPrice * item.quantity || item.original_line_price,
      finalLinePrice: item.final_line_price,
      quantity: "".concat(item.quantity),
      discounts: item.discounts,
      onQtyChange: handleLineItemQtyChange
    });
  }))));
}
CartListing.propTypes = {
  initialCart: PropTypes.object.isRequired,
  headerCountElem: PropTypes.object.isRequired,
  subtotalElem: PropTypes.object.isRequired,
  savingsElem: PropTypes.object.isRequired,
  savingsContainerElem: PropTypes.object.isRequired,
  onCartUpdate: PropTypes.func
};